/**
 * 网站配置文件
 */

var config = {
  appName: 'ColaPay',
  appLogo: '../assets/logo.png'
};
export default config;